/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef } from 'react';
import add from 'date-fns/add';
import sub from 'date-fns/sub';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  MdClose,
  MdDirectionsBus,
  MdOutlineArrowBack,
  MdOutlineCreate,
  MdOutlineFilterAlt,
  MdOutlineMail,
  MdOutlineNorth,
  MdOutlineSouth,
  MdOutlineWhatsapp,
} from 'react-icons/md';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import isSameDay from 'date-fns/isSameDay';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { Col, Row } from 'react-bootstrap';
import NoSearchResults from '../../one-way/NoSearchResults';
import './BusSearchResults.scss';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';
import AppSidebar from '../../../shared/components/app-sidebar/AppSidebar';
import BusSearch from '../bus-search/BusSearch';
import AppButton from '../../../shared/components/app-button/AppButton';
import {
  formatDate,
  getNewDate,
  hideHeaderFooterInMobile,
  isAfterDate,
  isMobileWidth,
  showHeaderFooterInMobile,
} from '../../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  DATE_MONTH_DAY_FORMAT,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import BusCard from './BusCard';
import { searchBusesApi } from '../../../api/busApi';
import BusFilters from './BusFilters';
import AppModal from '../../../shared/components/app-modal/AppModal';
import { emailFlightOptions } from '../../../api/flightApi';
import { getUserDetails } from '../../../api/profileApi';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import BusEmailShareModal from './BusEmailShareModal';
import BusWhatsAppShareModal from './BusWhatsAppShareModal';
import { useAppContext } from '../../../saas/AppConfigWrapper';

const SORT_OPTIONS = {
  departureTime: 'Departure',
  duration: 'Duration',
  arrivalTime: 'Arrival',
  price: 'Price',
};

function BusSearchResults() {
  const { appConfig } = useAppContext();
  const [isLoading, setLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [searchParams] = useSearchParams();
  const [searchRequest, setSearchRequest] = useState({
    origin: {
      placeid: '',
      place_type: 'bus',
      place_name: '',
    },
    destination: {
      placeid: '',
      place_type: 'bus',
      place_name: '',
    },
    jdate: '',
    agentid: '',
    currency: appConfig?.appCurrency,
    numadults: 1,
    numchildren: 0,
    numinfants: 0,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchDone, setSearchDone] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const [minBusFare, setMinBusFare] = useState(0);
  const [maxBusFare, setMaxBusFare] = useState(0);
  const allBusTypesRef = useRef([]);
  const allBusOperatorsRef = useRef([]);
  const [selectedFilters, setSelectedFilters] = useState({
    selectedMinPrice: minBusFare,
    selectedMaxPrice: maxBusFare,
    selectedDepartureTimes: [],
    selectedArrivalTimes: [],
    selectedOperators: [],
    selectedBusTypes: [],
    selectedAcTypes: [],
    selectedLayoutTypes: [],
    selectedBusName: '',
  });
  const allSearchResultsRef = useRef([]);
  const [isModifySearch, setIsModifySearch] = useState(false);
  const [responseSearchRequest, setResponseSearchRequest] = useState({});
  const [sortParam, setSortParam] = useState('price');
  const [sortOrder, setSortOrder] = useState('asc');
  const navigate = useNavigate();
  const [showCommission, setShowCommission] = useState(false);
  const [dateDict, setDateDict] = useState([-3, -2, -1, 0, 1, 2, 3]);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openWhatsappModal, setOpenWhatsappModal] = useState(false);
  const [busOptionsToShare, setBusOptionsToShare] = useState([]);

  useEffect(() => {
    hideHeaderFooterInMobile();
    return () => showHeaderFooterInMobile();
  }, []);

  const getBusesSearchResults = async (mergedSearchObj) => {
    setSearchRequest(mergedSearchObj);
    const dateDiff = differenceInCalendarDays(
      getNewDate(mergedSearchObj.jdate),
      getNewDate(TODAY_DATE),
    );
    if (dateDiff === 0) {
      setDateDict([0, 1, 2, 3, 4, 5, 6]);
    } else if (dateDiff === 1) {
      setDateDict([-1, 0, 1, 2, 3, 4, 5]);
    } else if (dateDiff === 2) {
      setDateDict([-2, -1, 0, 1, 2, 3, 4]);
    } else {
      setDateDict([-3, -2, -1, 0, 1, 2, 3]);
    }
    setLoading(true);
    const response = await searchBusesApi(mergedSearchObj);
    if (response.statuscode === '200') {
      let bases = response?.buses || [];
      bases = bases.sort((option1, option2) =>
        option1.seatdetails.seatfare > option2.seatdetails.seatfare ? 1 : -1,
      );
      allSearchResultsRef.current = bases;
      const minFare = bases?.[0]?.seatdetails?.seatfare || '';
      const maxFare = bases?.[bases.length - 1]?.seatdetails?.seatfare || '';

      setMinBusFare(minFare);
      setMaxBusFare(maxFare);
      setSearchResults(bases);
      bases.forEach((bus) => {
        if (allBusTypesRef.current.indexOf(bus.bustype) === -1) {
          allBusTypesRef.current.push(bus.bustype);
        }
        if (allBusOperatorsRef.current.indexOf(bus.operatorname) === -1) {
          allBusOperatorsRef.current.push(bus.operatorname);
        }
      });
      setResponseSearchRequest(response.searchrequest || {});
      setSearchDone(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Search',
        description: response.statusmessage || 'No Buses Found',
      });
      setSearchResults([]);
    }
    setSearchDone(true);
    setLoading(false);
  };

  const resetSearchResults = () => {
    allSearchResultsRef.current = [];
    allBusOperatorsRef.current = [];
    setMinBusFare(0);
    setMaxBusFare(0);
    allBusTypesRef.current = [];
    setSearchResults([]);
    setSearchDone(false);
    setIsModifySearch(false);
    setSelectedFilters({
      selectedMinPrice: 0,
      selectedMaxPrice: 0,
      selectedDepartureTimes: [],
      selectedArrivalTimes: [],
      selectedOperators: [],
      selectedBusTypes: [],
      selectedAcTypes: [],
      selectedLayoutTypes: [],
      selectedBusName: '',
    });
    setBusOptionsToShare([]);
  };

  useEffect(() => {
    if (searchParams) {
      const currentParams = Object.fromEntries([...searchParams]);
      const dict = Object.keys(currentParams)
        .filter((d) => d.startsWith('origin') || d.startsWith('destination'))
        .reduce((acc, d) => {
          const textAfterReplace = d.replaceAll(']', '');
          const arr = textAfterReplace.split('[');
          const objName = arr[0];
          const propName = arr[1];
          if (acc[objName] == null) acc[objName] = {};
          acc[objName][propName] = currentParams[d];
          delete currentParams[d];
          return acc;
        }, {});
      const mergedSearchObj = {
        ...searchRequest,
        ...currentParams,
        ...dict,
      };
      resetSearchResults();
      setSearchRequest(mergedSearchObj);
      getBusesSearchResults(mergedSearchObj);
    }
  }, [searchParams]);

  const handleSort = (param) => {
    const prevSortParam = sortParam;
    let order = 'asc';
    if (prevSortParam === param) {
      order = sortOrder === 'desc' ? 'asc' : 'desc';
    }
    const list = [...searchResults];
    if (param === 'price') {
      if (order === 'desc') {
        list.sort((option1, option2) =>
          option2.seatdetails.seatfare > option1.seatdetails.seatfare ? 1 : -1,
        );
      } else {
        list.sort((option1, option2) =>
          option1.seatdetails.seatfare > option2.seatdetails.seatfare ? 1 : -1,
        );
      }
    } else if (param === 'duration') {
      if (order === 'desc') {
        list.sort((option1, option2) => option2.duration - option1.duration);
      } else {
        list.sort((option1, option2) => option1.duration - option2.duration);
      }
    } else if (param === 'departureTime') {
      if (order === 'desc') {
        list.sort((option1, option2) =>
          option2.deptime > option1.deptime ? 1 : -1,
        );
      } else {
        list.sort((option1, option2) =>
          option1.deptime > option2.deptime ? 1 : -1,
        );
      }
    } else if (param === 'arrivalTime') {
      if (order === 'desc') {
        list.sort((option1, option2) =>
          option2.arrtime > option1.arrtime ? 1 : -1,
        );
      } else {
        list.sort((option1, option2) =>
          option1.arrtime > option2.arrtime ? 1 : -1,
        );
      }
    } else if (param === 'numSeats') {
      if (order === 'desc') {
        list.sort((option1, option2) =>
          option2.seatdetails?.numseatsavailable >
          option1.seatdetails?.numseatsavailable
            ? 1
            : -1,
        );
      } else {
        list.sort((option1, option2) =>
          option1.seatdetails?.numseatsavailable >
          option2.seatdetails?.numseatsavailable
            ? 1
            : -1,
        );
      }
    }
    setSortParam(param);
    setSortOrder(order);
    setSearchResults(list);
  };

  const handleSearchByDate = async (date) => {
    if (searchRequest && searchRequest.jdate) {
      const request = { ...searchRequest };
      const reqDate = formatDate(getNewDate(date), API_DATE_FORMAT);
      request.jdate = reqDate;
      resetSearchResults();
      await getBusesSearchResults({ ...request });
    }
  };

  const handleApplyFilter = (filters) => {
    setSelectedFilters(filters);
    setOpenFilters(false);
    let filteredresults =
      filters.selectedBusName !== ''
        ? allSearchResultsRef.current.filter(
            (resultRow) =>
              resultRow.operatorname
                .toLowerCase()
                .includes(filters.selectedBusName.toLowerCase()) ||
              resultRow.bustype
                .toLowerCase()
                .includes(filters.selectedBusName.toLowerCase()),
          )
        : allSearchResultsRef.current;
    filteredresults =
      filters.selectedDepartureTimes.length > 0
        ? filteredresults.filter((resultRow) => {
            const depTime = Number(resultRow.deptime);
            return filters.selectedDepartureTimes.some((timeRange) => {
              const timeRnageArr = timeRange.split('-');
              return (
                depTime >= Number(timeRnageArr[0]) &&
                depTime <= Number(timeRnageArr[1])
              );
            });
          })
        : filteredresults;
    filteredresults =
      filters.selectedArrivalTimes.length > 0
        ? filteredresults.filter((resultRow) => {
            const depTime = Number(resultRow.arrtime);
            return filters.selectedArrivalTimes.some((timeRange) => {
              const timeRnageArr = timeRange.split('-');
              return (
                depTime >= Number(timeRnageArr[0]) &&
                depTime <= Number(timeRnageArr[1])
              );
            });
          })
        : filteredresults;
    filteredresults =
      filters.selectedBusTypes.length > 0
        ? filteredresults.filter((resultRow) => {
            return filters.selectedBusTypes.some(
              (bustype) => resultRow.bustype === bustype,
            );
          })
        : filteredresults;
    filteredresults =
      filters.selectedLayoutTypes.length > 0
        ? filteredresults.filter((resultRow) => {
            let selectedTypes = [...filters.selectedLayoutTypes];
            if (filters.selectedLayoutTypes.indexOf('seater') > -1) {
              selectedTypes.push('semisleeper');
            }
            return selectedTypes.some(
              (bustype) => resultRow.seatdetails?.seattype === bustype,
            );
          })
        : filteredresults;
    filteredresults =
      filters.selectedAcTypes.length > 0
        ? filteredresults.filter((resultRow) => {
            return filters.selectedAcTypes.some(
              (bustype) => resultRow.acnonac === bustype,
            );
          })
        : filteredresults;
    filteredresults =
      filters.selectedOperators.length > 0
        ? filteredresults.filter((resultRow) => {
            return filters.selectedOperators.some(
              (operator) => resultRow.operatorname === operator,
            );
          })
        : filteredresults;

    filteredresults = filters.selectedMinPrice
      ? filteredresults.filter(
          (resultRow) =>
            resultRow.seatdetails?.seatfare >= filters.selectedMinPrice,
        )
      : filteredresults;
    filteredresults = filters.selectedMaxPrice
      ? filteredresults.filter(
          (resultRow) =>
            resultRow.seatdetails?.seatfare <= filters.selectedMaxPrice,
        )
      : filteredresults;

    setSearchResults(filteredresults);
  };

  const handleShowFilters = () => {
    setOpenFilters(true);
  };

  const onModifyClick = () => {
    setIsModifySearch(true);
  };

  const handleBook = (
    selectedSeats,
    userPreference,
    busData,
    seatResponseId,
  ) => {
    const boardingPoint =
      busData.boardingpoints?.find(
        (d) => String(d.id) === String(userPreference.from),
      ) || {};
    const droppingPoint =
      busData.droppoints?.find(
        (d) => String(d.id) === String(userPreference.to),
      ) || {};
    navigate(NAVIGATION_ROUTES.BUS.REVIEW_BOOKING, {
      state: {
        selectedBus: busData,
        searchRequest: responseSearchRequest,
        selectedSeats,
        boardingPoint,
        droppingPoint,
        seatResponseId,
      },
    });
  };

  const isSelectedDate = (index) => {
    const date = add(getNewDate(searchRequest.jdate), {
      days: index,
    });
    return isSameDay(getNewDate(searchRequest.jdate), date);
  };

  const handleOpenWhatsappModal = () => {
    if (busOptionsToShare.length > 0) {
      setOpenWhatsappModal(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Share via WhatsApp',
        description: 'Select atleast one option',
      });
    }
  };
  const handleOpenEmailModal = () => {
    if (busOptionsToShare.length > 0) {
      setOpenEmailModal(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Share via Email',
        description: 'Select atleast one option',
      });
    }
  };

  const handleBusSelectionForShare = (bus) => {
    setBusOptionsToShare((prevItems) => {
      if (
        prevItems.some(
          (selectedItem) => selectedItem.nextrabusid === bus.nextrabusid,
        )
      ) {
        return prevItems.filter(
          (selectedItem) => selectedItem.nextrabusid !== bus.nextrabusid,
        );
      }
      return [...prevItems, bus];
    });
  };

  const handleSendEmail = async (senderEmail, emailContent) => {
    setLoading(true);
    let fromEmail = '';
    let fromName = '';
    const res = await getUserDetails(getUserAgentId());
    if (res.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      fromEmail = User.ContactEmail;
      fromName = `${User.FirstName} ${User.LastName}`;
    }
    if (fromEmail !== '') {
      const emailSubject = `Your Bus booking details for ${
        searchRequest.origin.place_name
      } - 
      ${searchRequest.destination.place_name} | ${formatDate(
        getNewDate(searchRequest.jdate),
        API_DATE_FORMAT,
      )}`;
      const response = await emailFlightOptions(
        fromEmail,
        fromName,
        senderEmail,
        emailContent,
        emailSubject,
      );
      if (response && response.Root?.Status === 'OK') {
        setAlert({
          title: 'Email',
          description: 'Email Sent Successfully',
          variant: 'success',
        });
        setOpenEmailModal(false);
        setLoading(false);
        setBusOptionsToShare([]);
      } else {
        setAlert({
          title: 'Email',
          description: response.Root?.Message
            ? response.Root?.Message
            : 'Failed to send email',
          variant: 'error ',
        });
        setOpenEmailModal(false);
        setLoading(false);
      }
    } else {
      setAlert({
        title: 'User Details',
        description: res.ApiStatus?.Message
          ? res.ApiStatus?.Message
          : 'Failed to load Agent Details',
        variant: 'error ',
      });
      setOpenEmailModal(false);
      setLoading(false);
    }
    setOpenEmailModal(false);
    setLoading(false);
  };

  const handleCloseWhatsappModal = () => {
    setBusOptionsToShare([]);
    setOpenWhatsappModal(false);
  };

  return (
    <section className="bus-search-results-page">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {searchRequest && isSearchDone && (
        <div className="modify-search-container">
          {isMobileWidth() ? (
            <div>
              <div className="d-flex justify-content-between align-items-center white-color p-2">
                <div className="d-flex">
                  <AppIconButton
                    onClick={() => navigate(-1)}
                    className="white-color p-0"
                    variant="transparent"
                  >
                    <MdOutlineArrowBack />
                  </AppIconButton>
                  <div className="d-flex justify-content-between p-1 align-items-center flex-1">
                    <div className="fs-14 white-color">
                      <div>
                        {searchRequest.origin.place_name} to{' '}
                        {searchRequest.destination.place_name}
                      </div>
                      <div className="fs-10">
                        {formatDate(
                          getNewDate(searchRequest.jdate),
                          DATE_MONTH_YEAR_VIEW_FORMAT,
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  {isModifySearch ? (
                    <AppIconButton
                      className="white-color p-0"
                      variant="transparent"
                      onClick={() => setIsModifySearch(false)}
                    >
                      <MdClose className="fs-4" />
                    </AppIconButton>
                  ) : (
                    <AppIconButton
                      className="white-color p-0"
                      variant="transparent"
                      onClick={() => setIsModifySearch(true)}
                    >
                      <MdOutlineCreate className="fs-4" />
                    </AppIconButton>
                  )}
                </div>
              </div>
              {isModifySearch && (
                <BusSearch previousSearchRequest={searchRequest} />
              )}
            </div>
          ) : (
            <BusSearch previousSearchRequest={searchRequest} />
          )}
        </div>
      )}
      {isSearchDone && (
        <div className="bus-search-results-page__body">
          <Row>
            {!isMobileWidth() && (
              <Col lg={3} className="hide-in-mobile">
                <BusFilters
                  minPrice={minBusFare}
                  maxPrice={maxBusFare}
                  selectedFilters={selectedFilters}
                  allBusTypes={allBusTypesRef.current}
                  allBusOperators={allBusOperatorsRef.current}
                  onApplyFilter={handleApplyFilter}
                />
              </Col>
            )}
            <Col lg={9} md={12} sm={12} xs={12}>
              {!isMobileWidth() ? (
                <div
                  style={{
                    // position: 'sticky',
                    top: '150px',
                    height: 'fit-content',
                    zIndex: '90',
                    backgroundColor: '#f2f2f2',
                  }}
                >
                  <div className="fs-5 fw-500 d-flex justify-content-between align-items-center">
                    <span className="d-block" style={{ width: '700px' }}>
                      Buses From {searchRequest.origin.place_name} to{' '}
                      {searchRequest.destination.place_name}
                    </span>
                    <div>
                      <span className="fs-10">
                        {searchResults.length} Buses Found
                      </span>
                      <AppIconButton
                        variant="transparent"
                        className="fs-14"
                        onClick={handleOpenWhatsappModal}
                      >
                        <MdOutlineWhatsapp title="WhatsApp" />
                      </AppIconButton>
                      <AppIconButton
                        variant="transparent"
                        className="fs-14"
                        onClick={handleOpenEmailModal}
                      >
                        <MdOutlineMail title="Email" />
                      </AppIconButton>
                      <AppIconButton
                        variant="transparent"
                        className="fs-14"
                        onClick={() => setShowCommission((prev) => !prev)}
                      >
                        {showCommission ? (
                          <IoMdEyeOff title="Net Fare" />
                        ) : (
                          <IoMdEye title="Net Fare" />
                        )}
                      </AppIconButton>
                    </div>
                  </div>
                  <div className="my-1 d-flex fs-12 overflow-auto spacing-0 hide-in-mobile">
                    {dateDict.map((newDate) => (
                      <div
                        key={newDate}
                        className={`col search-by-date-btn grey-color ${
                          newDate === 7 ? 'last-date' : ''
                        } ${isSelectedDate(newDate) ? 'today-date-btn' : ''}`}
                        onClick={() =>
                          handleSearchByDate(
                            add(getNewDate(searchRequest.jdate), {
                              days: newDate,
                            }),
                          )
                        }
                      >
                        {newDate > 0 ? (
                          <span>
                            {formatDate(
                              add(getNewDate(searchRequest.jdate), {
                                days: newDate,
                              }),
                              DATE_MONTH_DAY_FORMAT,
                            )}
                          </span>
                        ) : (
                          <span>
                            {formatDate(
                              add(getNewDate(searchRequest.jdate), {
                                days: newDate,
                              }),
                              DATE_MONTH_DAY_FORMAT,
                            )}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                  <div
                    className="my-2"
                    style={{
                      // position: 'sticky',
                      top: '150px',
                      height: 'fit-content',
                      zIndex: '90',
                    }}
                  >
                    <div className="flight-sort-options d-flex">
                      <div
                        className={`sort-btn d-flex align-items-center justify-content-center ${
                          sortParam === 'price' ? 'selected-sort-btn' : ''
                        }`}
                        onClick={() => handleSort('price')}
                      >
                        Price{' '}
                        {sortParam === 'price' &&
                          (sortOrder === 'desc' ? (
                            <MdOutlineNorth />
                          ) : (
                            <MdOutlineSouth />
                          ))}
                      </div>
                      <div
                        className={`sort-btn border-inline d-flex align-items-center justify-content-center ${
                          sortParam === 'duration' ? 'selected-sort-btn' : ''
                        }`}
                        onClick={() => handleSort('duration')}
                      >
                        Duration{' '}
                        {sortParam === 'duration' &&
                          (sortOrder === 'desc' ? (
                            <MdOutlineNorth />
                          ) : (
                            <MdOutlineSouth />
                          ))}
                      </div>
                      <div
                        className={`sort-btn border-inline d-flex align-items-center justify-content-center ${
                          sortParam === 'departureTime'
                            ? 'selected-sort-btn'
                            : ''
                        }`}
                        onClick={() => handleSort('departureTime')}
                      >
                        Depart{' '}
                        {sortParam === 'departureTime' &&
                          (sortOrder === 'desc' ? (
                            <MdOutlineNorth />
                          ) : (
                            <MdOutlineSouth />
                          ))}
                      </div>
                      <div
                        className={`sort-btn d-flex align-items-center justify-content-center ${
                          sortParam === 'numSeats' ? 'selected-sort-btn' : ''
                        }`}
                        onClick={() => handleSort('numSeats')}
                      >
                        Seats{' '}
                        {sortParam === 'numSeats' &&
                          (sortOrder === 'desc' ? (
                            <MdOutlineNorth />
                          ) : (
                            <MdOutlineSouth />
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="p-2 d-flex  justify-content-between">
                  <div className="d-flex gap-3 flex-1">
                    <div
                      className={` d-flex align-items-center justify-content-center ${
                        sortParam === 'price' ? 'primary-color' : 'black-color'
                      }`}
                      onClick={() => handleSort('price')}
                    >
                      Price{' '}
                      {sortParam === 'price' &&
                        (sortOrder === 'desc' ? (
                          <MdOutlineNorth />
                        ) : (
                          <MdOutlineSouth />
                        ))}
                    </div>
                    <div
                      className={` d-flex align-items-center justify-content-center ${
                        sortParam === 'duration'
                          ? 'primary-color'
                          : 'black-color'
                      }`}
                      onClick={() => handleSort('duration')}
                    >
                      Duration{' '}
                      {sortParam === 'duration' &&
                        (sortOrder === 'desc' ? (
                          <MdOutlineNorth />
                        ) : (
                          <MdOutlineSouth />
                        ))}
                    </div>
                    <div
                      className={`d-flex align-items-center justify-content-center ${
                        sortParam === 'departureTime'
                          ? 'primary-color'
                          : 'black-color'
                      }`}
                      onClick={() => handleSort('departureTime')}
                    >
                      Depart{' '}
                      {sortParam === 'departureTime' &&
                        (sortOrder === 'desc' ? (
                          <MdOutlineNorth />
                        ) : (
                          <MdOutlineSouth />
                        ))}
                    </div>
                    <div
                      className={` d-flex align-items-center justify-content-center ${
                        sortParam === 'numSeats'
                          ? 'primary-color'
                          : 'black-color'
                      }`}
                      onClick={() => handleSort('numSeats')}
                    >
                      Seats{' '}
                      {sortParam === 'numSeats' &&
                        (sortOrder === 'desc' ? (
                          <MdOutlineNorth />
                        ) : (
                          <MdOutlineSouth />
                        ))}
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-1">
                    <AppIconButton
                      className="p-0"
                      variant="transparent"
                      onClick={() => setOpenFilters(true)}
                    >
                      <MdOutlineFilterAlt className="fs-4" />
                    </AppIconButton>
                    <AppIconButton
                      variant="transparent"
                      className="fs-4 p-0"
                      onClick={handleOpenWhatsappModal}
                    >
                      <MdOutlineWhatsapp title="WhatsApp" />
                    </AppIconButton>
                    <AppIconButton
                      variant="transparent"
                      className="fs-4 p-0"
                      onClick={handleOpenEmailModal}
                    >
                      <MdOutlineMail title="Email" />
                    </AppIconButton>
                  </div>
                </div>
              )}
              {searchResults.length > 0 ? (
                <div className="bus-search-results-page__body_card-section">
                  {searchResults.map((d, index) => (
                    <div key={`${index}_${d.uniquekey}`}>
                      <BusCard
                        busData={d}
                        searchRequest={searchRequest}
                        onBook={handleBook}
                        showCommission={showCommission}
                        busOptionsToShare={busOptionsToShare}
                        onSelectForShare={handleBusSelectionForShare}
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <NoSearchResults title="No Buses Found">
                  <MdDirectionsBus style={{ transform: 'rotate(-90deg)' }} />
                </NoSearchResults>
              )}
            </Col>
          </Row>
        </div>
      )}
      {openFilters && (
        <AppSidebar
          sidebarTitle="Filters"
          showActions
          onHideSidebar={() => setOpenFilters(false)}
          className="p-0"
        >
          <BusFilters
            minPrice={minBusFare}
            maxPrice={maxBusFare}
            selectedFilters={selectedFilters}
            allBusTypes={allBusTypesRef.current}
            allBusOperators={allBusOperatorsRef.current}
            onApplyFilter={handleApplyFilter}
          />
        </AppSidebar>
      )}
      {openEmailModal && (
        <AppModal
          modalTitle="Send Email"
          size="lg"
          showCloseButton
          onModalClose={() => setOpenEmailModal(false)}
        >
          <BusEmailShareModal
            busOptionsToShare={busOptionsToShare}
            searchRequest={searchRequest}
            onSend={handleSendEmail}
          />
        </AppModal>
      )}
      {openWhatsappModal && (
        <AppModal
          modalTitle="Send WhatsApp"
          size="lg"
          showCloseButton
          onModalClose={() => setOpenWhatsappModal(false)}
        >
          <BusWhatsAppShareModal
            busOptionsToShare={busOptionsToShare}
            searchRequest={searchRequest}
            onClearWhatsApp={handleCloseWhatsappModal}
          />
        </AppModal>
      )}
    </section>
  );
}

BusSearchResults.defaultProps = {};

BusSearchResults.propTypes = {};

export default BusSearchResults;
